// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/app.scss
// module id = 22
// module chunks = 0